var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSessionCountImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#1DA687"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5488_17380",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5488_17380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.45 26.475L16.25 23.275L17.325 22.2L19.45 24.325L23.675 20.1L24.75 21.175L19.45 26.475ZM13.8 30C13.3 30 12.875 29.825 12.525 29.475C12.175 29.125 12 28.7 12 28.2V14.8C12 14.3 12.175 13.875 12.525 13.525C12.875 13.175 13.3 13 13.8 13H15.2V10.875H16.725V13H24.3V10.875H25.8V13H27.2C27.7 13 28.125 13.175 28.475 13.525C28.825 13.875 29 14.3 29 14.8V28.2C29 28.7 28.825 29.125 28.475 29.475C28.125 29.825 27.7 30 27.2 30H13.8ZM13.8 28.5H27.2C27.2667 28.5 27.3333 28.4667 27.4 28.4C27.4667 28.3333 27.5 28.2667 27.5 28.2V18.8H13.5V28.2C13.5 28.2667 13.5333 28.3333 13.6 28.4C13.6667 28.4667 13.7333 28.5 13.8 28.5Z",
    fill: "#E0F8F2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionCountImg);
export default __webpack_public_path__ + "static/media/session-count-img.2fe07cd473a0a7ed8fa9618dfb57ef97.svg";
export { ForwardRef as ReactComponent };